import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from './auth.service';

// Dashboard is dark by default (config('dashboard.enabled') pending QC
// review); direct navigation to /dashboard while it is off redirects to
// '/users/me' instead of rendering a dead route. '/users/me' (not
// market-vacancies) because it carries no role restriction, so it's
// guaranteed terminal even for a role-NA user or one with no client membership.
@Injectable({
  providedIn: 'root'
})
export class DashboardEnabledGuard {

  constructor(private auth: AuthService, private router: Router) {
  }

  canActivate(): Observable<boolean | UrlTree> {
    return this.auth.user.pipe(
      take(1),
      // isNew users get through regardless of the flag: /dashboard is their
      // only self-serve onboarding page (DashboardComponent's `@if (isNew)`
      // branch), independent of the metrics content the flag actually gates.
      map(user => (user?.dashboard_enabled || this.auth.isNew) ? true : this.router.createUrlTree(['/users/me'])),
    );
  }
}
